import { getUserItem } from './getItem';
export var executeWebStorageGetUserItem = function (_a) {
    var identity = _a.identity, storageKey = _a.storageKey;
    if (!identity) {
        return undefined;
    }
    return getUserItem(identity.puid, storageKey) || undefined;
};
//# sourceMappingURL=executeWebStorageGetUserItem.js.map